import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import { Figure, StyledFigcaption } from "scmp-app/components/content/content-cover-image/styles";
import {
  H2Container as ContentSubHeadlineH2Container,
  H3Container as ContentSubHeadlineH3Container,
} from "scmp-app/components/content/content-sub-headline/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: grid;
  grid:
    "cover-image" min-content
    "content" min-content
    / 100%;
  gap: 12px;

  color: #000000;
  ${theme.breakpoints.up("tablet")} {
    grid: "content cover-image" min-content / minmax(260px, 338px) minmax(400px, 590px);
    gap: 32px;
  }
  ${theme.breakpoints.up("desktop")} {
    display: flex;
    flex-direction: row-reverse;
    gap: 0;
  }
`;

export const Content = styled.div`
  grid-area: content;

  ${theme.breakpoints.up("desktop")} {
    flex: 1 0 calc(40% - 32px);

    margin-inline-end: 32px;
  }
`;

export const StyledEntityLink = styled(EntityLink)``;

export const CoverImageStyledEntityLink = styled(StyledEntityLink)`
  grid-area: cover-image;

  min-inline-size: 0;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 590px;
  }
  ${theme.breakpoints.up("desktop")} {
    flex: 1 0 60%;

    max-inline-size: 714px;
  }
`;

export const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 25.2px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 22px;
    line-height: 30.8px;
  }
`;

export const LiveTagContainer = styled.div`
  margin-block-end: 8px;

  :empty {
    margin-block-end: 0;
  }
`;

export const SubHeadline = styled.div`
  margin-block-start: 12px;

  color: #6f6f6f;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18.2px;

  ${ContentSubHeadlineH2Container}, ${ContentSubHeadlineH3Container} {
    li + li {
      margin-block-start: 12px;
    }
  }
`;

export const ActionBar = styled.div`
  margin-block-start: 12px;
  time {
    color: #999999;
    font-size: 12px;
    line-height: 14px;
  }
`;

export const CoverImage = styled.div`
  block-size: auto;
  margin-inline: -20px;

  overflow: hidden;
  ${Figure} {
    aspect-ratio: 3/2;
  }

  ${StyledFigcaption} {
    display: none;

    ${theme.breakpoints.up("tablet")} {
      display: block;

      line-height: 14px;
    }
  }
  ${theme.breakpoints.up("tablet")} {
    margin-inline: 0;
  }
  ${theme.breakpoints.up("desktop")} {
    max-block-size: 718px;
  }
`;

const SubContentStyle = css`
  margin-block-start: 20px;
  padding-block-start: 20px;
  border-block-start: 1px solid rgba(0, 0, 0, 0.1);
`;

export const SubContentInDesktop = styled.div`
  display: none;
  ${theme.breakpoints.up("desktop")} {
    display: block;
    ${SubContentStyle};
  }
`;
